import { Subject } from "rxjs";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: "app-notification-sequence",
	styleUrls: ["./notification-sequence.component.scss"],
	templateUrl: "./notification-sequence.component.html"
})

export class NotificationSequenceComponent implements OnChanges {
	public close$ = new Subject<void>();
	@Input() public style?: "hidden" |"show";
	@Input() public message?: string;
	@Input() public exceptionMessage?: string;
	@Input() public type: "error" | "warning" | "success" = "success";

	constructor(private cdr: ChangeDetectorRef) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if ("style" in changes){
			this.cdr.detectChanges();
		}
	}

	public copyMsg(): void {
		navigator.clipboard?.writeText(this.exceptionMessage!);
	}

	public checkMsgLength(): boolean {
		return this.exceptionMessage?.length! > 1000;
	}

	public getTitle(): string {
		return $localize`Копировать сообщение`;
	}
}